// extracted by mini-css-extract-plugin
export default {"attachmentsLoader":"attachments-loader_attachmentsLoader__m-KLA","attachmentsLoaderTitle":"attachments-loader_attachmentsLoaderTitle__Nabbb"};